import { Button, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import "./ModalPageEvent.css";
import ModalCloseButton from "./ModalCloseButton";

const ModalPageEvent = (props) => {

    const { t } = useTranslation();
    const { show, setShow, title, child, size, btnOnClick, btnText, btnCloseOnClick, btnCloseText, btnDisabled = false, centered = false, dialogClassName, showCloseButton = false } = props;

    /**
     * Aciona a ação de fechar padrão ou customizada.
     */
    const handleClose = () => {
        (!btnCloseOnClick) ? setShow(false) : btnCloseOnClick();
    }

    const resolvedDialogClassName = ['modal-page-event__dialog', dialogClassName].filter(Boolean).join(' ');

    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade modal-page-event" size={size} show={show} onHide={handleClose} centered={centered} dialogClassName={resolvedDialogClassName}>
                <Modal.Header className="modal-page-event__header">
                    <Modal.Title className="modal-page-event__title">{title}</Modal.Title>
                    <button
                        type="button"
                        onClick={handleClose}
                        className="modal-page-event__close"
                        aria-label={t('close')}
                        title={t('close')}
                    >
                        <i className="fa-solid fa-xmark" aria-hidden="true" />
                    </button>
                </Modal.Header>
                <Modal.Body className="modal-page-event__body">
                    {child}
                </Modal.Body>
                {/* Modal só de consulta fecha pelo X do cabeçalho: um botão "Fechar" isolado no
                    rodapé parece uma decisão a ser tomada, e não a saída da tela. Quando existe
                    ação principal, o rodapé volta com o par confirmar/fechar, que aí sim é uma
                    escolha. Use showCloseButton para forçar o botão em um caso específico. */}
                {(btnOnClick || showCloseButton) && (
                    <Modal.Footer className="modal-page-event__footer">
                        <ModalCloseButton
                            onClick={() => handleClose()}
                        >
                            {(!btnCloseText) ? t('close') : btnCloseText}
                        </ModalCloseButton>
                        {btnOnClick && (
                            <Button variant="primary" onClick={btnOnClick} disabled={btnDisabled} className="modal-page-event__btn is-primary">
                                {btnText}
                            </Button>
                        )}
                    </Modal.Footer>
                )}
            </Modal>
        </>
    )
}

export default ModalPageEvent;
